import { Button, Card, CardContent, CardHeader } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { DataTable } from '@/components/ui/data.table/data-table';
import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import PaginationComponent from '@/components/ui/pagination';
import { DEFAULT_PAGE_LIMIT, Route } from '@/constants';

import { OrderHeadingActions } from './order-heading-action.component';
import { orderListColumns } from './order-list.column';
import { useOrderList } from './order-list.hook';

export const OrderList = () => {
    const { data, isLoading, page, setCurrentPage } = useOrderList();

    const renderContent = () => {
        return (
            <>
                <DataTable
                    columns={orderListColumns}
                    data={data?.data || []}
                    isLoading={isLoading}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <PaginationComponent
                    showTotalItems
                    totalItems={data?.pagination?.total_items || 0}
                    itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                    initialPage={page}
                    onPageChange={(p) => {
                        setCurrentPage(p);
                    }}
                />
            </>
        );
    };

    return (
        <div>
            <HeadingWrapper>
                <div className="flex items-center justify-between">
                    <PageHeading title="Sales" subTitle="Manage Your Sales" />
                    <Link to={Route.POS_NEW}>
                        <Button type="button" variant={'default'}>
                            Create New Sale
                        </Button>
                    </Link>
                </div>
            </HeadingWrapper>

            <Card className="mt-4">
                <CardHeader>
                    <div className="flex flex-col items-end justify-start gap-4 sm:flex-row sm:items-center">
                        <OrderHeadingActions />
                    </div>
                </CardHeader>
                <CardContent>{renderContent()}</CardContent>
            </Card>
        </div>
    );
};

OrderList.displayName = 'OrderList';
